import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableColumn from "../types/order-optimizer-taxi-details-hidden-details-center-tables-driver-table-column";

const getColumns =
  (): OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableColumn[] => {
    const tableColumns: OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableColumn[] =
      [
        {
          header: "",
          title: "",
          accessor: "driverTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "driverHaltingTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "driverDrivingTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "driverDistance",
          colSpan: 3,
        },
      ];

    return tableColumns;
  };

const orderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableHelper = {
  getColumns,
};

export default orderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableHelper;
